import { Link } from '@@/Link';

import { columnHelper } from './helper';

export const registry = columnHelper.accessor('registryName', {
  header: 'Registry',
  cell: ({ row }) => (
    <Link
      to={`/admin/registries/${row.original.registryId}`}
      data-cy={`registry-link-${row.original.registryId}`}
    >
      {row.original.registryName || 'Unknown'}
    </Link>
  ),
  meta: {
    className: 'w-1/3',
  },
});
